"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { dataSecurityServer } from "../../../../../public/images/legal-information";
import Section from "../Section";

const DataSecurity = () => {
  const t = useTranslations("dataSecurity.sections");
  const tHead = useTranslations("dataSecurity.head");

  return (
    <div className="gs--page-column flex flex-col gap-5 py-16">
      <Section title={t("section1.title")}>
        <p>{t("section1.text1")}</p>
      </Section>

      <Section title={t("section2.title")}>
        <p>{t("section2.text1")}</p>
        <p>{t("section2.text2")}</p>
      </Section>

      <Section title={t("section3.title")}>
        <p>{t("section3.text1")}</p>
      </Section>

      <Section title={t("section4.title")}>
        <p>{t("section4.text1")}</p>
      </Section>

      <Section title={t("section5.title")}>
        <p>{t("section5.text1")}</p>
      </Section>

      <Section title={t("section6.title")}>
        <p>{t("section6.text1")}</p>
      </Section>

      <Image
        src={dataSecurityServer}
        alt={tHead("imageAlt")}
        width={1200}
        height={800}
        className="self-center"
      />
    </div>
  );
};

export default DataSecurity;
